import { render, staticRenderFns } from "./InstantSearch.vue?vue&type=template&id=a50d1c10&scoped=true"
import script from "./InstantSearch.vue?vue&type=script&lang=js"
export * from "./InstantSearch.vue?vue&type=script&lang=js"
import style0 from "./InstantSearch.vue?vue&type=style&index=0&id=a50d1c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50d1c10",
  null
  
)

export default component.exports